import React, { createContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    // 如果用户之前选择了dark主题，自动迁移到light（花粉女神主题）
    if (saved === 'dark') {
      localStorage.setItem('theme', 'light');
      return 'light';
    }
    // 默认使用light（花粉女神主题）
    return saved || 'light';
  });

  const [customColors, setCustomColors] = useState(() => {
    const saved = localStorage.getItem('customColors');
    return saved ? JSON.parse(saved) : {};
  });

  useEffect(() => {
    const root = document.documentElement;
    localStorage.setItem('theme', theme);
    localStorage.setItem('customColors', JSON.stringify(customColors));
    
    if (theme === 'default') {
      // 科技男神主题
      root.style.setProperty('--primary-color', '#ff6b9d');
      root.style.setProperty('--secondary-color', '#c471ed');
      root.style.setProperty('--bg-color', '#0a0e27');
      root.style.setProperty('--surface-color', '#1a1f3a');
      root.style.setProperty('--text-primary', '#ffffff');
      root.style.setProperty('--text-secondary', '#b0b8d1');
      root.style.setProperty('--accent-color', '#00d4ff');
    } else if (theme === 'light') {
      // 花粉女神主题
      root.style.setProperty('--primary-color', '#ff6b9d');
      root.style.setProperty('--secondary-color', '#c471ed');
      root.style.setProperty('--bg-color', '#f5f7fa');
      root.style.setProperty('--surface-color', '#ffffff');
      root.style.setProperty('--text-primary', '#1a1a1a');
      root.style.setProperty('--text-secondary', '#666666');
      root.style.setProperty('--accent-color', '#00d4ff');
    } else if (theme === 'custom') {
      // 自定义主题
      Object.keys(customColors).forEach(key => {
        root.style.setProperty(`--${key}`, customColors[key]);
      });
    }
  }, [theme, customColors]);

  const updateCustomColors = (colors) => {
    setCustomColors(colors);
    setTheme('custom');
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, customColors, updateCustomColors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;

